import { useEffect, useState } from "react";
import api from "../lib/api";

// Module-level cache — quote statuses are static config from the backend,
// no point fetching them more than once per page load.
let cache = null;
let inflight = null;

export default function useQuoteStatuses() {
  const [statuses, setStatuses] = useState(cache || []);

  useEffect(() => {
    if (cache) {
      setStatuses(cache);
      return;
    }
    if (!inflight) {
      inflight = api.get("/catalog/quote-statuses")
        .then((r) => {
          cache = r.data || [];
          return cache;
        })
        .catch(() => {
          // Fall back to a sane default if the endpoint fails so the UI
          // doesn't render an empty dropdown.
          cache = [
            { id: "draft", label_it: "Bozza", is_default: true },
            { id: "sent", label_it: "Inviato" },
            { id: "viewed", label_it: "Visto" },
            { id: "accepted", label_it: "Accettato" },
            { id: "rejected", label_it: "Rifiutato" },
          ];
          return cache;
        });
    }
    inflight.then((data) => setStatuses(data));
  }, []);

  return statuses;
}
